import { render } from "./dashboard_organizer_checkbib.vue?vue&type=template&id=234ba8de"
import script from "./dashboard_organizer_checkbib.vue?vue&type=script&lang=js"
export * from "./dashboard_organizer_checkbib.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__